import supportersTypes from './supporters.types';
import axios from 'axios';
import Socket from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/supporters`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/supporters`;
}

const io = Socket(url);

export default {
  fetchsupporters({ commit }) {
    const ls = storage.get('manager');
    commit(supportersTypes.FETCH_supporterS_REQUEST);
    const options = {
      url: `${url}/all?resultSize=10000&page=1`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(supportersTypes.FETCH_supporterS_SUCCESS, {
          data: { supporters: res.data.supporters.docs }
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(supportersTypes.FETCH_supporterS_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(supportersTypes.FETCH_supporterS_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(supportersTypes.FETCH_supporterS_FAILED, { error });
      });
  },
  deletesupporter({ commit }, supporter) {
    const ls = storage.get('manager');
    commit(supportersTypes.DELETE_supporter_REQUEST);
    axios
      .delete(`${url}/supporter/${supporter.id}`, {
        headers: {
          Authorization: `Bearer ${ls.token}`
        }
      })
      .then(() => {
        commit(supportersTypes.DELETE_supporter_SUCCESS);
        io.emit('fetch supporters', { manager_email: ls.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(supportersTypes.DELETE_supporter_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(supportersTypes.DELETE_supporter_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(supportersTypes.DELETE_supporter_FAILED, { error });
      });
  }
};
